import SearchContainer from "./SearchContainer"

export default SearchContainer;